import { render, staticRenderFns } from "./SIS_StudentOverview.vue?vue&type=template&id=2929b1dc&"
import script from "./SIS_StudentOverview.vue?vue&type=script&lang=ts&"
export * from "./SIS_StudentOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports